<template>
  <CCard class="p-0 card-programs">
    <CCardHeader><span class="f-18">Mon profil</span></CCardHeader>
    <CCardBody class="text-white">
      <CCard
        col="12"
        :style="{ 'background-color': program.color || '#6B6FC6' }"
        class="flex-row align-items-center p-2 w-100 cursor-pointer"
        v-for="(program, index) in programs"
        :key="index"
        @click="() => $router.push({ name: 'Programs', params: { id: program.id } })"
      >
        <div>
          <div class="progress progress-circle mr-2">
            <span class="progress-left">
              <span class="progress-bar" :style="progressBar(program.progress > 50 ? (program.progress - 50) * 2 : 0)"></span>
            </span>
            <span class="progress-right">
              <span class="progress-bar" :style="progressBar(program.progress > 50 ? 100 : program.progress)"></span>
            </span>
            <div class="progress-value">
              <div>{{ roundFloatValue(program.progress || 0, 0) }}%</div>
            </div>
          </div>
        </div>
        <div>
          <p class="text-white m-0 pt-1 font-weight-bolder">{{ program.title }}</p>
        </div>
        <a
          @click="() => $router.push({ name: 'Programs', params: { id: program.id } })"
          class="pr-1 font-weight-light ml-auto d-lg-down-none white-space-nowrap"
        >
          Voir + <span class="text-white align-middle">→</span>
        </a>
      </CCard>
    </CCardBody>
  </CCard>
</template>

<script>
import utils from '../../utils';

export default {
  name: 'programsProgression',
  data() {
    return {
      programs: [],
    };
  },
  watch: {
    // eslint-disable-next-line
    '$store.state.selectedProfile': async function () {
      await this.getPrograms();
    },
  },
  async mounted() {
    await this.getPrograms();
  },
  methods: {
    roundFloatValue: utils.roundFloatValue,
    progressBar(progress) {
      return { transform: `rotate(${(progress * 180) / 100}deg)` };
    },
    async getPrograms() {
      const { data } = await this.$http.get(
        `/api/stats/dashboard/profile_program?filters[profileId]=${this.$store.state.selectedProfile && this.$store.state.selectedProfile.id}`,
      );
      if (data && data.body) {
        const profilePrograms = data.body;

        this.programs = profilePrograms.map((item) => item.Program);
      }
    },
  },
};
</script>
